/* SIMI PERÚ — JS personalizado.
   Patrón: una init() por componente, todas se llaman al DOMContentLoaded.
   Cada init comprueba si su elemento existe antes de actuar. */

(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // ---------- Reveal on scroll ----------
  function initReveal() {
    var els = $$('.sm-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---------- Marquee (duplica contenido para loop infinito) ----------
  function initMarquee() {
    $$('.sm-marquee__row').forEach(function (row) {
      if (row.dataset.duplicated) return;
      row.dataset.duplicated = '1';
      var clone = row.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      row.parentNode.appendChild(clone);
      clone.classList.add('sm-marquee__row');
    });
  }

  // ---------- Carrusel de productos ----------
  function initProductsCarousel() {
    $$('.sm-products').forEach(function (sec) {
      var track = $('.sm-products__track', sec);
      var prev = $('.sm-products__nav [data-dir="prev"]', sec);
      var next = $('.sm-products__nav [data-dir="next"]', sec);
      if (!track || !prev || !next) return;
      var card = track.querySelector('.sm-product');
      var step = function () { return card ? card.offsetWidth + 22 : 280; };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    });
  }

  // ---------- Contador animado (stats) ----------
  function initCounters() {
    var els = $$('.sm-stat__num[data-count]');
    if (!els.length) return;
    function setFinal(el) {
      el.textContent = (el.dataset.prefix || '') + formatNum(el.dataset.count, el.dataset.suffix, parseFloat(el.dataset.count));
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(setFinal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animateNum(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
    // Salvavidas: si el observer no dispara por cualquier motivo, nunca dejar la cifra en 0.
    setTimeout(function () {
      els.forEach(function (el) {
        if (parseFloat(el.textContent) === 0 || el.textContent.trim() === '') setFinal(el);
      });
    }, 2600);
  }
  function animateNum(el) {
    var target = parseFloat(el.dataset.count) || 0;
    var dur = 1600;
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';
    var t0;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = target * eased;
      el.textContent = prefix + formatNum(v, suffix, target);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function formatNum(v, suffix, target) {
    v = Math.round(parseFloat(v) || 0);
    // Un año ("Desde 2023") no lleva separador de miles: "2023", no "2,023".
    var esAnio = !suffix && v >= 1900 && v <= 2100;
    var formatted = esAnio ? String(v) : v.toLocaleString('es-PE');
    return formatted + (suffix || '');
  }

  // ---------- Galería de producto ----------
  function initProductGallery() {
    var gal = $('.sm-pp-gallery');
    if (!gal) return;
    var main = $('.sm-pp-main img', gal);
    var thumbs = $$('.sm-pp-thumb', gal);
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.dataset.full || t.querySelector('img').src;
        // La imagen principal es adaptable (srcset). Si no lo limpiamos, el
        // navegador ignora el nuevo src y se seguiría viendo la foto anterior.
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        gal.dataset.smFoto = String(thumbs.indexOf(t));
      });
    });
  }

  // ---------- Visor ampliado de la ficha (mejora 2026-10-16) ----------
  // Lupa o clic en la foto principal → <dialog> con la foto en 2000 px; flechas, teclado (← →, Esc) y deslizar.
  // En escritorio, clic en la foto ampliada = acercar 2,2× y recorrer con el cursor.
  function initProductZoom() {
    var gal = $('.sm-pp-gallery');
    var dlg = gal && $('[data-sm-zoom]', gal);
    var datos = gal && $('[data-sm-zoom-fotos]', gal);
    if (!dlg || !datos || typeof dlg.showModal !== 'function') return;
    var fotos = [];
    try { fotos = JSON.parse(datos.textContent) || []; } catch (e) { return; }
    if (!fotos.length) return;
    var img = $('[data-sm-zoom-img]', dlg);
    var escenario = $('[data-sm-zoom-stage]', dlg);
    var cuenta = $('[data-sm-zoom-count]', dlg);
    var actual = 0;
    var origen = null;

    function mostrar(i) {
      actual = (i + fotos.length) % fotos.length;
      escenario.classList.remove('is-zoom');
      img.style.transformOrigin = '';
      img.src = fotos[actual];
      if (cuenta) cuenta.textContent = 'Foto ' + (actual + 1) + ' de ' + fotos.length;
    }
    function abrir() {
      origen = document.activeElement;
      mostrar(parseInt(gal.dataset.smFoto || '0', 10) || 0);
      dlg.showModal();
      document.documentElement.classList.add('sm-zoom-abierto');
    }
    function cerrar() { if (dlg.open) dlg.close(); }

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('sm-zoom-abierto');
      if (origen && origen.focus) origen.focus();
    });
    $$('[data-sm-zoom-open]', gal).forEach(function (b) { b.addEventListener('click', abrir); });
    var principal = $('.sm-pp-main img', gal);
    if (principal) principal.addEventListener('click', abrir);
    $('[data-sm-zoom-close]', dlg).addEventListener('click', cerrar);
    var prev = $('[data-sm-zoom-prev]', dlg), next = $('[data-sm-zoom-next]', dlg);
    if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
    if (next) next.addEventListener('click', function () { mostrar(actual + 1); });
    // Clic fuera de la foto (en el fondo del visor) cierra
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === escenario) cerrar(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); mostrar(actual - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); mostrar(actual + 1); }
    });
    // Acercar con clic (solo con puntero fino: en el celular se usa el pellizco del propio navegador)
    var fino = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    img.addEventListener('click', function (e) {
      if (!fino) return;
      e.stopPropagation();
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      escenario.classList.toggle('is-zoom');
    });
    img.addEventListener('mousemove', function (e) {
      if (!escenario.classList.contains('is-zoom')) return;
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    // Deslizar para cambiar de foto
    var x0 = null;
    escenario.addEventListener('touchstart', function (e) { if (e.touches.length === 1) x0 = e.touches[0].clientX; }, { passive: true });
    escenario.addEventListener('touchend', function (e) {
      if (x0 === null || fotos.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) mostrar(actual + (dx < 0 ? 1 : -1));
    });
  }

  // ---------- Variantes de producto ----------
  function initProductVariants() {
    var form = $('.sm-pp-form');
    if (!form) return;
    var data = $('script[type="application/json"][data-variants]', form);
    if (!data) return;
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = $('input[name="id"]', form);
    var priceEl = $('.sm-pp-price');
    var addBtn = $('.sm-pp-add');
    var buyBtn = form.querySelector('[data-sm-buy]');
    var groups = $$('.sm-pp-variant-group', form);

    function getSelected() {
      return groups.map(function (g) {
        var act = g.querySelector('.sm-pp-variant-option.is-active');
        return act ? act.dataset.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }
    var qtyInput = $('.sm-pp-qty input', form);
    var stockEl = $('[data-sm-stock]');
    function actualizarStock(v) {
      var tope = (v.track && v.policy !== 'continue') ? v.inv : null;
      // input: max + re-clamp
      if (qtyInput) {
        if (tope && tope > 0) qtyInput.setAttribute('max', tope);
        else qtyInput.removeAttribute('max');
        qtyInput.dispatchEvent(new Event('change'));
      }
      // etiqueta de stock
      if (stockEl) {
        var dot = '<span class="sm-pp-stock__dot"></span>';
        var dotOut = '<span class="sm-pp-stock__dot sm-pp-stock__dot--out"></span>';
        if (v.track && v.policy !== 'continue') {
          if (v.inv > 0) {
            stockEl.innerHTML = dot + '<span class="sm-pp-stock__txt"><strong>' + v.inv + '</strong> ' +
              (v.inv === 1 ? 'unidad disponible' : 'unidades disponibles') + '</span>';
          } else {
            stockEl.innerHTML = dotOut + '<span class="sm-pp-stock__txt">Sin stock por ahora</span>';
          }
        } else {
          stockEl.innerHTML = dot + '<span class="sm-pp-stock__txt">Disponible</span>';
        }
      }
    }
    function applyVariant(v) {
      if (!v || !idInput) return;
      idInput.value = v.id;
      if (priceEl && v.price) priceEl.textContent = formatMoneyPEN(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (v.available) {
          addBtn.classList.remove('is-disabled');
          if (addBtn.dataset.labelAdd) addBtn.textContent = addBtn.dataset.labelAdd;
        } else {
          addBtn.classList.add('is-disabled');
          if (addBtn.dataset.labelOos) addBtn.textContent = addBtn.dataset.labelOos;
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.classList.toggle('is-disabled', !v.available);
      }
      actualizarStock(v);
    }
    function formatMoneyPEN(cents) {
      var n = parseFloat(cents) / 100;
      return 'S/ ' + n.toLocaleString('es-PE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
    groups.forEach(function (g) {
      $$('.sm-pp-variant-option', g).forEach(function (opt) {
        opt.addEventListener('click', function () {
          $$('.sm-pp-variant-option', g).forEach(function (x) { x.classList.remove('is-active'); });
          opt.classList.add('is-active');
          applyVariant(findVariant(getSelected()));
        });
      });
    });
  }

  // ---------- Cantidad (qty) ----------
  function initQty() {
    $$('.sm-pp-qty').forEach(function (wrap) {
      var minus = wrap.querySelector('[data-qty="-"]');
      var plus  = wrap.querySelector('[data-qty="+"]');
      var input = wrap.querySelector('input');
      if (!input) return;
      function topeMax() {
        var m = parseInt(input.getAttribute('max'), 10);
        return (isNaN(m) || m <= 0) ? Infinity : m;
      }
      function set(v) {
        var max = topeMax();
        var n = Math.max(1, Math.min(max, parseInt(v, 10) || 1));
        input.value = n;
        // Bloquea el botón + al llegar al stock máximo
        if (plus) plus.disabled = (n >= max);
        if (minus) minus.disabled = (n <= 1);
      }
      if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      if (plus)  plus.addEventListener('click',  function () { set(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { set(input.value); });
      set(parseInt(input.value, 10) || 1);
    });
  }

  // ---------- Añadir al carrito desde las tarjetas (catálogo / destacados) ----------
  function initCardAddToCart() {
    // Delegado en el documento: funciona también con tarjetas que llegan después
    // (filtros de búsqueda/colección que reemplazan la rejilla sin recargar la página).
    if (window.__smCardDelegated) return;
    window.__smCardDelegated = true;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-card-form]');
      if (!form) return;
      e.preventDefault();
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var btn = form.querySelector('.sm-card-add');
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || !btn) return;
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var label = btn.querySelector('span') || btn;
      var original = label.textContent;
      btn.disabled = true; label.textContent = 'Agregando…';

      var body = { items: [{ id: idEl.value, quantity: qty }] };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) {  // error (p. ej. sin stock)
            label.textContent = 'Sin stock';
            setTimeout(function () { label.textContent = original; btn.disabled = false; }, 1800);
            return;
          }
          if (cart && cart.renderContents) {
            // El cajón trae la marca 'is-empty' si la página cargó con el carrito vacío; sin quitarla,
            // el cajón se abre en blanco (solo total y botón). Dawn la quita en product-form.js (2026-10-06).
            cart.classList.remove('is-empty');
            cart.renderContents(resp);            // abre y refresca el cajón de Dawn
          } else {
            window.location.href = '/cart';
          }
          btn.classList.add('is-added');
          label.textContent = '✓ Agregado';
          setTimeout(function () {
            label.textContent = original; btn.disabled = false; btn.classList.remove('is-added');
          }, 1600);
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  // Mensaje visible bajo los botones de la ficha (p. ej. límite de stock). QA final v2, 2026-10-16:
  // antes el motivo que da Shopify solo quedaba en la consola y el cliente no veía nada.
  function smAviso(form, texto) {
    var p = form.querySelector('.sm-pp-aviso');
    if (!p) {
      p = document.createElement('p');
      p.className = 'sm-pp-aviso';
      p.setAttribute('role', 'alert');
      form.appendChild(p);
    }
    p.textContent = texto;
    clearTimeout(p._smT);
    p._smT = setTimeout(function () { p.textContent = ''; }, 7000);
  }

  // ---------- Agregar al carrito desde la ficha: abre el carrito lateral (como las tarjetas) ----------
  // R2-28: antes llevaba a /cart. "Comprar ahora" sigue yendo directo al pago (initBuyNow).
  function initProductAddToDrawer() {
    var form = $('.sm-pp-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var cart = document.querySelector('cart-drawer');
      if (!cart || !cart.renderContents) return;          // sin cajón: envío normal a /cart
      e.preventDefault();
      var btn = form.querySelector('.sm-pp-add');
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || (btn && (btn.disabled || btn.classList.contains('is-disabled')))) return;
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: idEl.value, quantity: qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1 }],
          sections: cart.getSectionsToRender().map(function (s) { return s.id; }),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) {
            smAviso(form, resp.description || 'No hay más stock disponible de este producto.');
            if (btn) { btn.textContent = original; btn.disabled = false; }
            return;
          }
          cart.classList.remove('is-empty');
          cart.renderContents(resp);
          if (btn) { btn.textContent = original; btn.disabled = false; }
        })
        .catch(function () { form.submit(); });
    });
  }

  // ---------- Comprar ahora (página de producto) ----------
  // Agrega la variante + cantidad elegida al carrito y redirige directo al pago.
  function initBuyNow() {
    var form = $('.sm-pp-form');
    if (!form) return;
    var btn = form.querySelector('[data-sm-buy]');
    if (!btn) return;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var label = btn.querySelector('[data-buy-label]');

    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-disabled')) return;
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || !idEl.value) return;
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var original = label ? label.textContent : '';

      btn.classList.add('is-loading'); btn.disabled = true;
      if (label) label.textContent = 'Redirigiendo…';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ items: [{ id: idEl.value, quantity: qty }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) {  // error (p. ej. ya está en el carrito todo el stock disponible)
            var restaurar = function () {
              if (label) label.textContent = original;
              btn.disabled = false; btn.classList.remove('is-loading');
            };
            // Si el producto ya está en el carrito, igual se va al pago con lo que hay (el cliente quiere comprar).
            fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                var yaEsta = (c.items || []).some(function (i) { return String(i.variant_id) === String(idEl.value); });
                if (yaEsta) { window.location.href = '/checkout'; return; }
                smAviso(form, resp.description || 'No hay stock disponible de este producto.');
                restaurar();
              })
              .catch(function () { smAviso(form, resp.description || 'No hay stock disponible de este producto.'); restaurar(); });
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (label) label.textContent = original;
          btn.disabled = false; btn.classList.remove('is-loading');
        });
    });
  }

  // ---------- Header: buscador expandible (móvil) ----------
  function initHeaderSearch() {
    var btn = $('[data-sm-search-toggle]');
    var panel = $('[data-sm-search-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = panel.querySelector('input');
        if (input) setTimeout(function () { input.focus(); }, 80);
      }
    });
  }

  // ---------- Listas: abrir con "solo disponibles" ----------
  // Los agotados están publicados (Google los ve), pero al entrar a una lista
  // desde cualquier enlace (menú, portada, pie, migas) se añade
  // filter.v.availability=1 en el momento del clic, para mostrar primero lo que
  // se puede comprar. El HTML conserva el enlace original: los buscadores siguen
  // recorriendo la colección completa. No toca los enlaces marcados con
  // [data-sm-keep-links] (paginación, filtros y "Ver también agotados").
  // Se concatena el parámetro a mano (sin URLSearchParams) para no recodificar
  // los demás parámetros (p. ej. product_type con espacios y "/").
  function initSoloDisponibles() {
    function marcar(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.closest('[data-sm-keep-links]')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (!/^\/collections\/[^\/]+\/?$/.test(url.pathname)) return;
      if (url.search.indexOf('filter.v.availability') !== -1) return;
      a.href = url.pathname + url.search + (url.search ? '&' : '?') +
               'filter.v.availability=1' + url.hash;
    }
    // mousedown cubre clic central/ctrl+clic (pestaña nueva); click cubre teclado y táctil.
    document.addEventListener('mousedown', marcar, true);
    document.addEventListener('click', marcar, true);
  }

  // ---------- Boot ----------
  // El archivo se incluye desde varias secciones, así que el navegador lo
  // ejecuta varias veces. Este candado garantiza que todo se inicialice UNA
  // sola vez (si no, los botones +/- sumaban N veces por clic).
  if (window.__smBooted) return;
  window.__smBooted = true;

  // ---------- Carrusel promocional (ronda 3) ----------
  // Desliza con el dedo (scroll-snap), flechas, puntos y avance automático opcional.
  // El avance automático se pausa al pasar el mouse, al tocar, con el foco dentro,
  // con la pestaña oculta y si el usuario pidió reducir el movimiento.
  function initPromoSlider() {
    $$('[data-sm-slider]').forEach(function (sec) {
      if (sec.dataset.smReady) return;
      sec.dataset.smReady = '1';
      var track = $('[data-sm-slider-track]', sec);
      if (!track) return;
      var slides = Array.from(track.children);
      if (slides.length < 2) return;
      var dots = $$('[data-sm-slider-dots] button', sec);
      function ready() { sec.classList.add('is-ready'); }
      if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);
      ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) { sec.addEventListener(ev, ready, { once: true, passive: true }); });
      var idx = 0;
      function go(i) {
        ready();
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function mark() {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i === idx && dots[i] && dots[i].getAttribute('aria-current')) return;
        idx = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, k) { if (k === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      var prev = $('[data-sm-slider-prev]', sec), next = $('[data-sm-slider-next]', sec);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });

      var secs = parseInt(sec.dataset.autoplay, 10) || 0;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null, paused = false;
      function tick() { if (!paused && !document.hidden) go(idx + 1); }
      function restart() { if (timer) clearInterval(timer); if (secs && !reduce) timer = setInterval(tick, secs * 1000); }
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { sec.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { sec.addEventListener(ev, function () { paused = false; }); });
      restart();
    });
  }

  // ---------- Texto largo recortado con "Leer más" (descripción de colección) ----------
  function initClamp() {
    $$('[data-sm-clamp]').forEach(function (box) {
      var btn = box.parentNode.querySelector('[data-sm-clamp-btn]');
      if (!btn || box.scrollHeight <= box.clientHeight + 2) return;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Leer menos' : 'Leer más';
      });
    });
  }

  // ---------- Fotos de más abajo: esperan a que la página termine de cargar ----------
  // Así el primer pintado (título y textos) no compite con ~15 fotos que aún no se ven.
  function initDeferImages() {
    var root = document.documentElement;
    function ready() { root.classList.add('sm-loaded'); }
    // En su propio turno, después del evento "load" (no en el mismo turno que los scripts de medición de Shopify)
    function later() { if (window.requestIdleCallback) requestIdleCallback(ready, { timeout: 1500 }); else setTimeout(ready, 200); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    setTimeout(ready, 4000); // salvavidas: nunca más de 4 s sin fotos
  }

  function boot() {
    initReveal();
    initMarquee();
    initProductsCarousel();
    initPromoSlider();
    initDeferImages();
    initClamp();
    initCounters();
    initProductGallery();
    initProductZoom();
    initProductVariants();
    initQty();
    initCardAddToCart();
    initBuyNow();
    initProductAddToDrawer();
    initHeaderSearch();
    initSoloDisponibles();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
